import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DashboardLabelsFacade } from '@cpm-pr1618003/ng-initializer-lib';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LandingPageComponent } from './landing-page.component';
import { UserDialogView } from './landing-page.modal';
import { LandingPageFacade } from './store/facade/landing-page.facade';
import { UserPresenter } from './user/user.presenter';

@Component({
  selector: 'landing-page',
  templateUrl: './landing-page.container.component.html',
  styleUrl: './landing-page.container.component.scss',
  imports: [CommonModule, LandingPageComponent],
  standalone: true,
})
export class LandingPageContainerComponent implements OnInit {
  userDialogView$: Observable<UserDialogView> =
    this.landingPageFacade.activeSignButton$;
  subsciption = new Subscription();
  baseUrl: string = environment.baseUrl;
  constructor(
    private landingPageFacade: LandingPageFacade,
    private dashboardLabelsFacade: DashboardLabelsFacade,
    private userPresenter: UserPresenter,
  ) {}
  ngOnInit(): void {
    this.dashboardLabelsFacade.getDisplayLabels();
    this.subsciption.add(
      this.userDialogView$.subscribe((activeBtn: UserDialogView) => {
        this.resetForm();
      }),
    );
  }

  resetForm(): void {
    this.userPresenter.resetForm();
  }
}
